export default __webpack_public_path__ + "static/media/alarm.34cb559c.wav";